import React, { PureComponent, ReactNode } from "react";
import styled from "styled-components";

import { translate } from "../../../../../../../../../services/translation.service";
import theme, { media } from "../../../../../../../../../theme";
import Hyperlink from "../../../../../../../../Hyperlink";

const Article = styled.section`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin: 24px 0 15px 0;
  position: relative;

  &:not(:first-child) {
    border-left: 1px solid ${theme.colors.mediumGrey};
  }

  p {
    margin-bottom: 0;
  }

  ${media.laptop} {
    align-items: flex-start;
    margin: 0;

    p {
      margin-top: 5px;
    }

    &:not(:first-child) {
      border-left: none;
    }
  }
`;

const LinkStyled = styled(Hyperlink)<IProps>`
  text-align: center;

  ${media.laptop} {
    padding: 4px 0;
    font-weight: ${({ info }: IProps): number =>
      info === translate("footer.phoneNumber") ? 700 : 400};
    font-size: ${({ info }: IProps): string =>
      info === translate("footer.phoneNumber") ? "20px" : "15px"};
  }
`;

interface IProps {
  iconName?: string;
  info?: string;
  to: string;
  onClick?: () => void;
}

export default class ContactInfoItems extends PureComponent<IProps> {
  public render(): ReactNode {
    const { info, iconName, to, onClick } = this.props;

    return (
      <Article>
        <LinkStyled to={to} onClick={onClick} info={info}>
          {iconName && <img src={iconName} alt={info} />}
          <p>{info}</p>
        </LinkStyled>
      </Article>
    );
  }
}
